<template>
    <div class="collapsible" id="fournitures" :class="stateClass">

        <!-- HEADER CLIQUABLE -->
        <div id="head-fournitures" @click="$emit('openCollapsible', 'fournitures')"
        class="w-full flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer transition select-none mb-5" :class="stateClass === 'open' ? 'bg-gray-700' : 'bg-gray-200'">
            <span class="uppercase font-semibold tracking-wide " :class="stateClass === 'open' ? 'text-white' : 'text-gray-700'">
                FOURNITURES
            </span>

            <!-- Flèche dans un rond -->
            <div
                class="w-8 h-8 rounded-full flex items-center justify-center bg-white shadow text-secondary transition">
                <i class="inline-block h-6 w-6 mask mask-arrow-right bg-secondary transition-transform duration-300"
                    :class="stateClass === 'open' ? 'rotate-90' : 'rotate-0'"></i>
            </div>
        </div>

        <!-- CONTENU FOURNITURES — visible SEULEMENT si ouvert -->
        <div v-show="stateClass === 'open'">

            <!-- Liste des fournitures -->
            <ul v-for="f in fournitures" class="list-pieces bg-gray-100 rounded-xl p-4 space-y-3">
                <li :key="f.id" class="flex items-center justify-between gap-4 bg-white rounded-lg px-4 py-3 shadow-sm">
                    <!-- Désignation + état -->
                    <div class="flex-1">
                        <strong class="block text-sm text-gray-800">{{ f.designation }}</strong>
                        <span v-if="f.etat" class="text-xs text-gray-500">({{ f.etat }})</span>
                    </div>

                    <!-- Quantité + prix -->
                    <div class="text-right text-sm text-gray-700 font-medium whitespace-nowrap">
                        {{ f.qte }}
                        <span v-if="f.prix">× {{ f.prix }}€ HT</span>
                    </div>

                    <!-- Suppression -->
                    <button
                        class="inline-flex items-center justify-center bg-alert text-white rounded-lg px-3 py-1 text-sm transition hover:opacity-90"
                        @click="deletePiece(f.id)">
                        <i class="inline-block h-6 w-6 mask mask-trash bg-white"></i>
                    </button>
                </li>
            </ul>

            <!-- Ajouter une fourniture -->
            <a href="javascript: void 0;" id="add-piece" @click="addPiece" class="btn-secondary add-manip">
                Ajouter une fourniture
            </a>

        </div>
    </div>
</template>

<script>
import Piece from '../../../../js/models/Piece'

export default {

    data() {
        return {
            fournitures: []
        }
    },

    props: {
        open: null,
        pieces: {
            type: Array,
            default: []
        },
    },

    methods: {

        addPiece() {

            let form = `<div class="add-piece-swal grid grid-cols-1 gap-4">
                            <div>
                                <label class="label">Désignation</label>
                                <input class="input" type="text" id="designation" required="required" maxlength="255" />
                            </div>
                            <div>
                                <label class="label">Etat</label>
                                <select class="input" id="etat-piece">
                                    <option value="" selected></option>
                                    <option>Forfait</option>
                                    <option>Pièce à commander</option>
                                    <option>Pièce remplacée</option>
                                </select>
                            </div>
                            <div>
                                <label class="label">Quantité</label>
                                <input class="input" type="number" min="0" id="qte-piece">
                            </div>
                            <div>
                                <label class="label">Prix unitaire € (HT)</label>
                                <input class="input" type="number" min="0" step="0.01" id="prix-piece">
                            </div>
                        </div>`;

            swal({
                title: "Ajout d'une fourniture",
                html: form,
                focusConfirm: false,
                confirmButtonText: 'Ajouter',
                preConfirm: () => {

                    return new Promise((resolve, reject) => {

                        let designation = document.getElementById('designation').value;
                        let etat = document.getElementById('etat-piece').value;
                        let qte = document.getElementById('qte-piece').value;
                        let prix = document.getElementById('prix-piece').value;

                        if (qte && designation) {

                            resolve({
                                id: 'P-' + +new Date(),
                                fiche: this.$route.params.id,
                                designation,
                                etat,
                                qte,
                                prix
                            })

                        } else {
                            reject('Formulaire incomplet')
                        }

                    })

                }
            }).then(res => {

                this.fournitures.push(res);
                Piece
                    .addOffline(res)
                    .then(() => {
                        this.$emit('updatePieces', this.fournitures)
                    })
                    .catch()

            })
        },

        deletePiece(id) {

            Piece
                .remove(id)
                .then(() => {
                    this.fournitures = _.remove(this.fournitures, f => f.id !== id);
                    this.$emit('updatePieces', this.fournitures)
                })
                .catch()

        },

        fetchPieces() {

            let idFiche = this.$route.params.id;

            Piece
                .getListForFiche(idFiche)
                .then(res => this.fournitures = res)
                .catch()

        }

    },

    mounted() {

        this.fetchPieces()

    },

    computed: {

        stateClass() {
            if (this.open === 'fournitures') {
                return 'open'
            } else {
                return ''
            }
        }

    }

}
</script>


// WEBPACK FOOTER //
// GestionPieces.vue?f9dcfff4